import { Solution, Functions, Home, Media, Contact, Testimonies } from '../../sections';
import styles from './main.module.scss';
import { WhatsAppWidget } from 'react-whatsapp-widget';
import 'react-whatsapp-widget/dist/index.css';
import i18n from '../../configs/i18n';
import Divider from '../Divider';

const Main = () => {
	const userLang = i18n.language;

	return (
		<main className={styles.container}>
			<Home />
			<Divider color='green'/>
			<Solution />
			<Divider color='violet'/>
			<Functions />
			<Divider color='violet' reverse/>
			<Testimonies />
			<Divider color='green' reverse/>
			<Media />
			<Divider color='mix'/>
			<Contact/>
			<Divider color='violet' reverse />
		{ userLang === 'en' ? null :
			
			(
			<div className='whatsapp-widget'>
				<WhatsAppWidget 
				phoneNumber="56949077003" 
				companyName="BRAVE UP!" 
				sendButton="Mandar" 
				message="Hola, en que te podemos ayudar" 
				replyTimeText="#stopBullying"
				className='whatsapp-btn'
			/>
				</div>)

			} 
			
			
		</main>
	);
};

export default Main;
